import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ActiveCartFacade } from "@spartacus/cart/base/root";
import { EventService } from "@spartacus/core";
import { QuoteRequestButtonComponent } from "@spartacus/quote/components/request-button";
import { of, switchMap, tap } from "rxjs";
import { AttemptToCreateQuoteWithContractProductsEvent } from "src/app/core/events/gonvarri-attempt-create-quote-with-contract-products.event";
import { GonvarriProduct } from "src/app/core/models/gonvarri-product.model";

@Component({
    selector: 'cx-quote-request-button',
    templateUrl: './gonvarri-quote-request-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GonvarriQuoteRequestButtonComponent extends QuoteRequestButtonComponent {

  constructor(
    protected activeCartService: ActiveCartFacade,
    protected eventService: EventService,
  ) {
    super()
  }

  override goToQuoteDetails(): void {

    this.subscription.add(
      this.activeCartService.getEntries().pipe(
        switchMap((entries) => {
          // Check if there are products with contractReference in the cart (same logic as previously done in the custom accelerator QuoteController)
          const productsWithContract = this.getProductsWithContract(entries);

          if (productsWithContract.length > 0) {
            // If there are products with contractReference, dispatch the event with the products, which is captured by the cart details component
            console.warn('Products with contractReference found:', productsWithContract);
            const event = new AttemptToCreateQuoteWithContractProductsEvent();
            event.products = productsWithContract;
            this.eventService.dispatch(event);
          } else {
            // If there are no products with contractReference, create the quote
            this.quoteFacade.createQuote({}).pipe(
              tap((quote) => {
                this.routingService.go({
                  cxRoute: 'quoteDetails',
                  params: { quoteId: quote.code },
                });
              })
            ).subscribe();
          }

          return of(null); // Returns an empty observable to complete the subscription
        })
      ).subscribe()
    );

  }

  /**
   * Returns the products that have contractReference
   */
  private getProductsWithContract(entries: any[]): GonvarriProduct[] {
    return entries
      .filter(entry => {
        const contractReferences = (entry.product as GonvarriProduct).contractReference?.entry;
        return contractReferences && contractReferences.length > 0;
      })
      .map(entry => entry.product as GonvarriProduct);
  }

}
